import * as React from 'react';

import { Label, Icon } from './styles';

interface RadioBoxProps {
	name: string;
	label?: string | React.ReactNode;
	value: string;
	isChecked: boolean;
	isDisabled?: boolean;
	onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const RadioBox = ({
	name,
	label,
	value,
	isChecked,
	isDisabled,
	onChange,
}: RadioBoxProps) => (
	<Label isActive={isChecked}>
		<input
			type="radio"
			name={name}
			value={value}
			checked={isChecked}
			disabled={isDisabled}
			onChange={onChange}
		/>
		<Icon isActive={isChecked} />
		{label}
	</Label>
);

export default RadioBox;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RadioBox/index.tsx